import React, { FC, CSSProperties } from "react";
import SyntaxHighlighter from "react-syntax-highlighter/dist/esm/prism-light";
import ini from "react-syntax-highlighter/dist/esm/languages/prism/ini";
import shell from "react-syntax-highlighter/dist/esm/languages/prism/bash";
import js from "react-syntax-highlighter/dist/esm/languages/prism/javascript";
import tsx from "react-syntax-highlighter/dist/esm/languages/prism/tsx";
import css from "react-syntax-highlighter/dist/esm/languages/prism/css";
import markdown from "react-syntax-highlighter/dist/esm/languages/prism/markdown";
import { FancySyntaxHighlighterStyle } from "./fancy-highlight-style";
import * as scss from "./docs-code.scss";

SyntaxHighlighter.registerLanguage("ini", ini);
SyntaxHighlighter.registerLanguage("js", js);
SyntaxHighlighter.registerLanguage("css", css);
SyntaxHighlighter.registerLanguage("shell", shell);
SyntaxHighlighter.registerLanguage("tsx", tsx);
SyntaxHighlighter.registerLanguage("markdown", markdown);

export const Code: FC<{ id?: string }> = ({ children, id }) => (
	<code id={id} className={scss.code}>
		{children}
	</code>
);

export type language = "ini" | "shell" | "js" | "tsx" | "html" | "css" | "markdown";

export const CodeBlock: FC<{ language: language; id?: string; style?: CSSProperties }> = ({
	children,
	language,
	id,
	style,
}) => (
	<SyntaxHighlighter
		className={scss.codeBlock}
		language={language}
		style={FancySyntaxHighlighterStyle}
		id={id}
		customStyle={{ margin: "16px 0", ...style }} //override SyntaxHighlighers margin, but allow it to be overriden as well
		PreTag="div"
	>
		{children}
	</SyntaxHighlighter>
);
